import { Authenticator, AuthenticatorType } from '../types';

export interface AuthTokenRequest {
  readonly resource: string;
  successCallback(token: string): void;
  failureCallback(error: string): void;
}

export type GetAuthToken = (authTokenRequest: AuthTokenRequest) => void;

/**
 * Authenticator for Viva Connections
 */
export default class VivaConnectionsAuthenticator implements Authenticator {
  public readonly type = AuthenticatorType.VivaConnections;
  private getAuthToken: GetAuthToken;

  constructor(getAuthToken: GetAuthToken) {
    this.getAuthToken = getAuthToken;
  }

  public async acquireToken([resource]: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      this.getAuthToken({
        successCallback: resolve,
        failureCallback: (error) => {
          reject(new Error(error));
        },
        resource,
      });
    });
  }

  public acquireTokenRedirect() {
    throw new Error('Method not implemented.');
  }

  public setThirdPartyCookieErrorCallback() {
    throw new Error('Method not implemented.');
  }
}
